module.exports = __webpack_public_path__ + "static/img/cadrage_bg_2_1.6a5006e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cadrage_bg_2_1.png
// module id = vE0l
// module chunks = 1